import { render, staticRenderFns } from "./SavedListsPanel.vue?vue&type=template&id=54f3650d&"
import script from "./SavedListsPanel.vue?vue&type=script&lang=js&"
export * from "./SavedListsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports